// extracted by mini-css-extract-plugin
export default {"SimpleModal":"SimpleModal_SimpleModal__duYsO","XIcon":"SimpleModal_XIcon__-wRhI"};